import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { StoreModel } from '..';
import type { Injections } from '../services/injections';
import type { LedgerByAssestRequest, LedgerEntry, LedgerRequest } from '../services/LedgerService/types';

export interface LedgerModel {
  genericAssets: any[];
  ledgerEntries: LedgerEntry[];
  ledgerEntriesByAsset: LedgerEntry[];
  setLedgerEntries: Action<LedgerModel, LedgerEntry[]>;
  setLedgerEntriesByAsset: Action<LedgerModel, LedgerEntry[]>;
  setGenericAssets: Action<LedgerModel, any[]>;
  fetchLedgerEntries: Thunk<LedgerModel, LedgerRequest, Injections, StoreModel, Promise<LedgerEntry[]>>;
  fetchLedgerEntriesByAsset: Thunk<LedgerModel, LedgerByAssestRequest, Injections, StoreModel, Promise<LedgerEntry[]>>;
  fetchGenericAssets: Thunk<LedgerModel, LedgerByAssestRequest, Injections, StoreModel, Promise<LedgerEntry[]>>;
}

export const ledgerModel: LedgerModel = {
  genericAssets: [],
  ledgerEntries: [],
  ledgerEntriesByAsset: [],
  setLedgerEntries: action((state, data) => {
    state.ledgerEntries = data;
  }),
  setLedgerEntriesByAsset: action((state, data) => {
    state.ledgerEntriesByAsset = data;
  }),
  setGenericAssets: action((state, data) => {
    state.genericAssets = data;
  }),
  fetchLedgerEntries: thunk(async (actions, payload, { injections }) => {
    try {
      const res = await injections.ledgerService.fetchLedger(payload.asOfDateTime);
      actions.setLedgerEntries(res);
      return res;
    } catch (error) {
      return error;
    }
  }),
  fetchLedgerEntriesByAsset: thunk(async (actions, payload, { injections }) => {
    try {
      const res = await injections.ledgerService.fetchLedgerByAsset(
        payload.assetType,
        payload.assetId,
        payload.asOfDateTime,
      );
      actions.setLedgerEntriesByAsset(res);
      return res;
    } catch (error) {
      return error;
    }
  }),
  fetchGenericAssets: thunk(async (actions, payload, { injections }) => {
    try {
      const res = payload.assetType.includes('V2')
        ? await injections.ledgerService.fetchGenericAssetsV2(payload.assetType.slice(0, -2))
        : await injections.ledgerService.fetchGenericAssets(payload.assetType);
      const assetMap = res.map((asset: any) => {
        return {
          label: asset.name,
          value: asset[`${payload.assetId}`],
        };
      });
      actions.setGenericAssets(assetMap);
      return res;
    } catch (error) {
      actions.setGenericAssets([]);
      return error;
    }
  }),
};
